(() => {
  /* Code to close the Announcement bar */
  const selectors = {
    toolBar: "#shopify-section-toolbar",
    closeToolbar: "[data-toolbar-close]",
  };
  const $toolbar = document.querySelector(selectors.toolBar);
  const $closeToolbar = document.querySelector(selectors.closeToolbar);

  const setCookie = ({ key, value, days }) => {
    document.cookie = `${key}=${value}; path=/; max-age=${
      60 * 60 * 24 * days
    };`;
  };
  const getCookie = ({ key }) => {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${key}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  };
  if (getCookie({ key: "closeToolbar" })) {
    $toolbar.classList.add("hidden");
  }

  const hideToolbar = () => {
    $toolbar.classList.add("hidden");
    setCookie({ key: "closeToolbar", value: "closed", days: 14 });
  };
  if ($closeToolbar) {
    $closeToolbar.addEventListener("click", hideToolbar);
  }
  /* Code to toggle accordion menu wrappers for mobile version  */
  const mobileAccordionMenuSelectors = {
    accordion: ".hc-accordion",
    active: "hc-active",
  };
  const handleButton = (evt) => {
    evt.target.classList.toggle(mobileAccordionMenuSelectors.active);
    let panel = evt.target.nextElementSibling;
    panel.classList.toggle('hc-visible');
    panel.style.maxHeight = panel.style.maxHeight
      ? null
      : `100%`;
  };
  const $accordionButtons = document.querySelectorAll(
    mobileAccordionMenuSelectors.accordion
  );
  $accordionButtons.forEach(($accordion) => {
    $accordion.addEventListener("click", handleButton);
  });
  /* HC Code to open the default cart drawer by clicking the cart icon on mobile */
  const cartSelectors = {
    main_cart: "#HeaderCartTrigger",
    mobile_cart: "#HeaderCartTriggerAlt",
  };
  const $mainCartSelector = document.querySelector(cartSelectors.main_cart);
  const $mobileCartSelector = document.querySelector(cartSelectors.mobile_cart);

  $mobileCartSelector.addEventListener("click", (evt) => {
    evt.preventDefault();
    $mainCartSelector.click();
  });
  /* HC Code to handle the custom quantities selectors */
  const quantitySelectors = {
    decrease: ".hc-quantity-wrapper .btn-decrease",
    increase: ".hc-quantity-wrapper .btn-increase",
  };
  document.querySelectorEver(quantitySelectors.decrease, (el) => {
    el.addEventListener("click", function () {
      let input = this.parentNode.querySelector('[name="quantity"]');
      // Decrease by the step value
      input.stepDown();
    });
  });
  document.querySelectorEver(quantitySelectors.increase, (el) => {
    el.addEventListener("click", function () {
      let input = this.parentNode.querySelector('[name="quantity"]');
      // Increase by the step value
      input.stepUp();
    });
  });
  /* HC Code to handle quantity increments */
  document.querySelectorEver(".hc-quantity-wrapper [name='quantity']", (el) => {
    el.addEventListener("change", function (event) {
      const step = +this.step || 1;
      const value = +this.value || 1;
      const roundedValueByStep = Math.ceil(value / step) * step;
      this.value = roundedValueByStep;
    });
  });
  /* HC Code to add the product to cart from product grid item via AJAX */
  const miniForms = {
    form: ".hc-mini-cart",
  };
  const AddToCart = ({ items }) => {
    return fetch(theme.routes.cartAdd, {
      method: "POST",
      body: JSON.stringify(items),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => response.json());
  };
  const success = (product, ATCButton) => {
    ATCButton.classList.remove("btn--loading");
    document.dispatchEvent(
      new CustomEvent("ajaxProduct:added", {
        detail: {
          product: product,
          addToCartBtn: ATCButton,
        },
      })
    );
  };
  const handleSubmit = (evt) => {
    evt.preventDefault();
    const $form = evt.target;
    const formData = new FormData($form);
    const id = formData.get("id");
    const quantity = formData.get("quantity");
    const items = { id, quantity };
    const ATCButton = $form.querySelector(".add-to-cart");
    ATCButton.classList.add("btn--loading");
    AddToCart({ items }).then((product) => success(product, ATCButton));
  };
  document.querySelectorEver(miniForms.form, (el) => {
    el.addEventListener("submit", handleSubmit);
  });
  /* HC code to handle the 2nd menu on the mobile version */
  const altMenuSelectors = {
    nav: "#second.slide-nav",
    allLinks: "a.slide-nav__link",
    subNavToggleBtn: ".js-toggle-submenu",
    menuLevel: 1,
    childList: ".slide-nav__dropdown",
    isActive: "is-active",
    wrapper: ".slide-nav__wrapper",
  };
  const altMenuConfig = {};

  const setWrapperHeight = (wrapper, height) => {
    wrapper.style.height = `${height}px`;
  };
  const toggleMenu = (target, $altNav, altWrapper, targetMenu) => {
    if (targetMenu) {
      altMenuConfig.menuLevel = targetMenu.dataset.level;
      if (altMenuConfig.menuLevel == 2) {
        $altNav
          .querySelectorAll(`${altMenuSelectors.childList} [data-level="3"]`)
          .forEach((list) => {
            list.classList.remove(altMenuSelectors.isActive);
          });
      }
      targetMenu.classList.add(altMenuSelectors.isActive);
      setWrapperHeight(altWrapper, targetMenu.offsetHeight);
    } else {
      altMenuConfig.menuLevel = 1;
      altWrapper.removeAttribute("style");
      $altNav.querySelectorAll(altMenuSelectors.childList).forEach((list) => {
        list.classList.remove(altMenuSelectors.isActive);
      });
    }
  };
  const $altNav = document.querySelector(altMenuSelectors.nav) || null;
  if ($altNav) {
    const altWrapper = $altNav.closest(altMenuSelectors.wrapper);
    $altNav
      .querySelectorAll(altMenuSelectors.subNavToggleBtn)
      .forEach((btn) => {
        btn.addEventListener("click", function () {
          let { target } = btn.dataset;
          var targetMenu = document.querySelector(`[data-parent="${target}"]`);
          toggleMenu(target, $altNav, altWrapper, targetMenu);
          altWrapper.dataset.level = altMenuConfig.menuLevel;
        });
      });
  }
  /* HC code to add the Read more on the collection description page */
  const collectionSelectors = {
    wrapper: ".rte--collection-desc .enlarge-text",
  };
  $readMoreJS.init({
   target: collectionSelectors.wrapper,           // Selector of the element the plugin applies to (any CSS selector, eg: '#', '.'). Default: ''
   numOfWords: 50,               // Number of words to initially display (any number). Default: 50
   toggle: true,                 // If true, user can toggle between 'read more' and 'read less'. Default: true
   moreLink: theme.strings.readMore,    // The text of 'Read more' link. Default: 'read more ...'
   lessLink: theme.strings.readLess         // The text of 'Read less' link. Default: 'read less'
});
  

 /* const $collectionDescriptionWrapper =
    document.querySelector(collectionSelectors.wrapper) || null;
    if ($collectionDescriptionWrapper) {
            const DEFAULT_HEIGHT = 120;
            if ($collectionDescriptionWrapper.offsetHeight > DEFAULT_HEIGHT) {
                const readMore = new ReadMore({
                    height: `${DEFAULT_HEIGHT}px`,
                    wrapper: collectionSelectors.wrapper,
                    readMore: theme.strings.readMore,
                    readLess: theme.strings.readLess
                })
            }
    }*/
  /* HC Adding re buy feature account orders */
  const rebuySelectors = {
    buttons: ".hc-rebuy",
    headerCartTrigger: "#HeaderCartTrigger",
  };
  const $rebuyButtons =
    document.querySelectorAll(rebuySelectors.buttons) || null;
  if ($rebuyButtons) {
    $rebuyButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const { url } = this.dataset;
        fetch(`${url}?view=ajax`)
          .then((res) => res.json())
          .then((items) => AddToCart({ items }))
          .then((res) => {
            document.dispatchEvent(new CustomEvent("cart:build"));
            document.querySelector("#HeaderCartTrigger").click();
          });
      });
    });
  }
  const klaviyoFormsSelectors = {
    formSelectors: "[data-form-klaviyo]",
  };
  const $klaviyoForms =
    document.querySelectorAll(klaviyoFormsSelectors.formSelectors) || null;
  if ($klaviyoForms) {
    $klaviyoForms.forEach(($form) => {
      let $formData = new FormData($form);
      KlaviyoSubscribe.attachToForms(`#${$form.id}`, {
        hide_form_on_success: true,
        custom_success_message: true,
        success: function ($formElement) {
          var email = $formData.get("email");
          _learnq.push(["identify", { $email: email }]);
          _learnq.push(["track", "Signed Up for Newsletter"]);
          console.log($formElement);
          $form.style.display = "none";
        },
      });
    });
  }
  const downloadButtonsSelectors = {
    downloadButton: ".hc-download-button",
  };
  const $downloadButtons =
    document.querySelectorAll(downloadButtonsSelectors.downloadButton) || null;
  if ($downloadButtons) {
    $downloadButtons.forEach(($button) => {
      const url = $button.href;
      $button.addEventListener("click", (e) => {
        if ($button.dataset.canDownload !== "true") {
          e.preventDefault();
          $button.dataset.queueDownload = "true";
        }
      });
      fetch(url, {
        headers: new Headers({
          Origin: location.origin,
        }),
        mode: "cors",
      })
        .then((response) => response.blob())
        .then((blob) => {
          let blobUrl = window.URL.createObjectURL(blob);
          $button.setAttribute("href", blobUrl);
          $button.dataset.canDownload = "true";
          if ($button.dataset.queueDownload == "true") {
            $button.click();
            $button.datest.queueDownload = "false";
          }
        });
    });
  }
  const warningPopupSelectors = {
    modal: "#myModal",
    enterButton: ".btn--enter",
  };
  const $modal = document.querySelector(warningPopupSelectors.modal) || null;
  if ($modal) {
    $buttonEnter = $modal.querySelector(warningPopupSelectors.enterButton);
    if (!sessionStorage["disableExitIntent"]) {
      $modal.style.display = "block";
    }
    $buttonEnter.addEventListener("click", function (e) {
      e.preventDefault();
      sessionStorage["disableExitIntent"] = true;
      $modal.style.display = "none";
    });
  }
})();
